<template>
  <div ref="switching"></div>
</template>

<script>
import Switching from "!!raw-loader!../../assets/ricoh_assets/icons/BTN007n_switching.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.switching.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = Switching

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>

</style>